import apiRequest from "../../helpers/apiRequest";

export default async (body) => {
    return await apiRequest({
        method: 'post',
        url: `accounts/dj-rest-auth/login/`,
        data:body
    })
}
